const textColor = (editor, { value: color }) => {
  editor.chain().focus().setColor(color).run();
};

const unsetTextColor = (editor) => {
  editor.chain().focus().unsetColor().run();
};

export default {
  'text:color': textColor,
  'text:color:unset': unsetTextColor,
};
